import { postRequest } from '../services/api/apiService';

const isMetaSelected = (platforms = []) =>
  platforms.some((p) => {
    const v = String(p).toLowerCase();
    return v === 'facebook' || v === 'instagram';
  });

export async function fetchAudienceEstimate(
  formData,
  selectedAdAccount,
  setAudienceEstimate
) {
  if (!isMetaSelected(formData.publisherPlatform) || !selectedAdAccount) {
    setAudienceEstimate(null);
    return;
  }

  const publisherPlatforms = (formData.publisherPlatform || [])
    .map((p) => String(p).toLowerCase())
    .filter((p) => p === 'facebook' || p === 'instagram');

  try {
    const res = await postRequest('/api/ads/meta/reach-estimate', {
      adAccountId: selectedAdAccount,
      publisherPlatforms,
      countries: formData.location || [],
      age: formData.age || [],
      gender: formData.gender || 'All',
      languages: formData.languages || [],
      interests: formData.interests || [],
    });
    const data = res?.data;
    if (data && data.estimateReady) {
      setAudienceEstimate({
        lowerBound: data.lowerBound,
        upperBound: data.upperBound,
      });
    } else {
      setAudienceEstimate(null);
    }
  } catch (err) {
    console.error('Audience estimate failed:', err?.response?.data || err.message);
    setAudienceEstimate(null);
  }
}
